import FilterForm from '../../../components/forms/FilterForm';
import { CanAccess, HttpError } from '@refinedev/core';
import { EditButton, TextField, useTable } from '@refinedev/antd';
import { EyeOutlined } from '@ant-design/icons';
import { Form, Input, Space, Table } from 'antd';
import { IProductSet } from 'interfaces/product_sets';
import { ListLayout } from 'components/layout/layout/ListLayout';

export const ProductSetList = () => {
  const { tableProps, searchFormProps } = useTable<
    IProductSet,
    HttpError,
    { byName: string }
  >({
    onSearch: ({ byName }) => [
      {
        field: 'filter[by_name]',
        operator: 'eq',
        value: byName
      }
    ]
  });

  return (
    <ListLayout title="Sets de produtos">
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="byName">
          <Input placeholder="Nome do set de produtos" className="lg:w-96" />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="name"
          key="name"
          title="Nome"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="product_ids"
          key="product_ids"
          title="Produtos"
          render={({ length }) => <TextField value={length} />}
        />
        <Table.Column<IProductSet>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={80}
          render={(_, record) => {
            return (
              <Space>
                <CanAccess resource="products/sets" action="edit">
                  <EditButton
                    hideText
                    size="small"
                    icon={<EyeOutlined />}
                    recordItemId={record.id}
                  />
                </CanAccess>
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
